import { h } from "preact";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "preact/hooks";
import { useBlocker } from "react-router";

import i18n from "../../i18n.js";
import { createFormData } from "../../services/forms.js";
import projectsApi from "../../api/projects.js";

import BackButton from "../BackButton.jsx";
import Button from "../Button.jsx";
import SuccessState from "./SuccessState.jsx";
import PdfUpload from "./PdfUpload.jsx";
import { sendError } from "../../errors.js";
import { createToastMessage } from "../../store";
import UnsavedChangesPrompt from "../UnsavedChangesPrompt.jsx";

const FORM = {
  pdf: {
    validations: ["required"],
  },
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 10MB

export default function ProjectViaLink({ onBack }) {
  const { validate } = createFormData(FORM, {});
  const dispatch = useDispatch();

  const [file, setFile] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      !success && currentLocation.pathname !== nextLocation.pathname && file
  );

  function handleChange(f) {
    setError(null);
    setFile(f);
  }

  async function handleSubmit(event) {
    event.preventDefault();
    console.log("submit");
    setError(null);
    try {
      setSending(true);
      await projectsApi.createRequestViaPdf(file);
      setSuccess(true);
    } catch (err) {
      console.error(err.errors);
      if (err.errors) {
        setError(err.errors.pdf);
      } else {
        sendError(err);
        createToastMessage(dispatch, {
          type: "error",
          message: i18n.t(
            "component.projects_add.project_via_pdf.server_error"
          ),
        });
      }
    }
    setSending(false);
  }

  useEffect(validate, []);

  if (success) {
    return <SuccessState />;
  }

  return (
    <div class="row">
      <form class="col s9" method="post" action="#" onSubmit={handleSubmit}>
        <h1 class="t-h5 t-h5--margin">
          {i18n.t("component.projects_add.project_via_pdf.title")}
        </h1>
        <p class="t-body3 color-shades-charcoal mb-32">
          {i18n.t("component.projects_add.project_via_pdf.subtitle")}
        </p>

        <div class="mb-80">
          <PdfUpload maxSize={MAX_FILE_SIZE} onChange={handleChange} />

          {error && <p class="t-body4 color-semantic-error">{error}</p>}
        </div>

        <div>
          <BackButton
            class="mr-2"
            onClick={onBack}
            trackingName="backOnProjectViaLink"
            noIndent
          />
          <Button
            type="submit"
            disabled={sending || !file}
            trackingName="submitProjectViaLink"
          >
            {i18n.t("actions.submit")}
          </Button>
        </div>
      </form>
      {blocker.state === "blocked" ? (
        <UnsavedChangesPrompt
          acceptButton={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.ok"
          )}
          cancelButton={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.cancel"
          )}
          text={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.text"
          )}
          onAccept={() => blocker.proceed()}
          onCancel={() => blocker.reset()}
        />
      ) : null}
    </div>
  );
}
